import { IViewSettings } from "./ViewSettings"

export const INCLUDE_CURRENT_TENANT_DEFAULT = false

export interface IViewSettingsGlobalAssetOverview {
    includeCurrentTenant?: boolean
}

export default class ViewSettingsGlobalAssetOverview implements IViewSettings {
    includeCurrentTenant: boolean = INCLUDE_CURRENT_TENANT_DEFAULT

    constructor(data: IViewSettingsGlobalAssetOverview) {
        if (typeof data.includeCurrentTenant !== "undefined") {
            this.includeCurrentTenant = data.includeCurrentTenant
        }
    }

    get isDefault() {
        return this.includeCurrentTenant === INCLUDE_CURRENT_TENANT_DEFAULT
    }
}
